/**
 * Google OAuth 인증 Provider
 *
 * @react-oauth/google 라이브러리를 사용하여
 * Google 로그인을 처리합니다.
 */

import { GoogleOAuthProvider } from '@react-oauth/google'
import { ReactNode } from 'react'
import { env } from '@/core/config/env'

interface Props {
  children: ReactNode
}

/**
 * Google OAuth Provider
 *
 * 애플리케이션 최상위에서 사용하여 Google 로그인 기능을 제공합니다.
 *
 * @example
 * ```tsx
 * <GoogleAuthProvider>
 *   <App />
 * </GoogleAuthProvider>
 * ```
 */
export function GoogleAuthProvider({ children }: Props) {
  // Mock 모드에서는 Provider 없이 children만 반환
  if (env.USE_MOCK_DATA || !env.GOOGLE_CLIENT_ID) {
    console.warn('🔧 Mock 모드: Google OAuth Provider 비활성화')
    return <>{children}</>
  }

  return (
    <GoogleOAuthProvider clientId={env.GOOGLE_CLIENT_ID}>
      {children}
    </GoogleOAuthProvider>
  )
}
